// Libs
import axios from 'axios'
import _ from 'lodash'

// Actions
import { changeLocalLoading } from '../App/actions'
import { signOut } from '../Deauth/actions'
import { fetchFiles } from '../Drive/actions'

// Axios
import { serverAPI } from '../../index'

// Action types
export const CHANGE_SP_CASE_PAGE_LOADING = 'change_sp_case_page_loading'
export const CHANGE_SP_CASE = 'change_sp_case'
export const CHANGE_CHAT = 'change_chat'
export const CHANGE_CONFIRM = 'change_confirm'
export const CHANGE_FILE = 'change_file'
export const CHANGE_PING = 'change_ping'
export const CHANGE_MORE_INFOS_VISIBLE = 'change_more_infos_visible'
export const CHANGE_MORE_INFOS = 'change_more_infos'
export const CHANGE_MORE_INFOS_COMMENT = 'change_more_infos_comment'
export const CHANGE_CHECKOUT = 'change_checkout'
export const CHANGE_ARCHIVE_REASONS = 'change_archive_reasons'
export const CHANGE_VIEWED_OPPOSITE_PART = 'change_viewed_opposite_part'

// Axios Cancelation
export let changeChatCancel
export let uploadContractCancel

export const changeSpCasePageLoading = status => {
  return {
    type: CHANGE_SP_CASE_PAGE_LOADING,
    payload: status,
  }
}

export const changeSpCase = spCase => {
  return {
    type: CHANGE_SP_CASE,
    payload: spCase,
  }
}

export const changeChat = (spCaseId, message) => {
  return {
    type: CHANGE_CHAT,
    payload: message,
  }
}

export const changeConfirm = (visible, action, headline, message, buttonTitle1, buttonTitle2, file, minutaId) => {
  return {
    type: CHANGE_CONFIRM,
    payload: { visible, action, headline, message, buttonTitle1, buttonTitle2, file, minutaId },
  }
}

export const changeFile = file => {
  return {
    type: CHANGE_FILE,
    payload: file,
  }
}

export const changePing = status => {
  return {
    type: CHANGE_PING,
    payload: status,
  }
}

export const changeMoreInfosVisible = status => {
  return {
    type: CHANGE_MORE_INFOS_VISIBLE,
    payload: status,
  }
}

export const changeMoreInfos = (field, value) => {
  return {
    type: CHANGE_MORE_INFOS,
    payload: { field, value }
  }
}

export const changeMoreInfosComment = comment => {
  return {
    type: CHANGE_MORE_INFOS_COMMENT,
    payload: comment,
  }
}

export const changeCheckout = status => {
  return {
    type: CHANGE_CHECKOUT,
    payload: status,
  }
}

export const changeArchiveReasons = reasons => {
  return {
    type: CHANGE_ARCHIVE_REASONS,
    payload: reasons,
  }
}

export const changeViewedOppositePart = bool => {
  return {
    type: CHANGE_VIEWED_OPPOSITE_PART,
    payload: bool,
  }
}

export const fetchSpCase = (id, role, spCaseId) => {
  return dispatch => {
    dispatch(changeSpCasePageLoading(true))
    return serverAPI.get(`/case/${spCaseId}`)
      .then(response => {
        dispatch(changeCheckout(false))
        dispatch(changeSpCasePageLoading(false))
        dispatch(changeSpCase(response.data))
        dispatch(fetchFiles(spCaseId))
      })
      .catch(e => {
        dispatch(changeSpCasePageLoading(false))
      })
  }
}

export const actionChat = (id, spCaseId, action, message, file, minutaId, agreedValue, hadObligation, archiveReason, archiveObservation, expectedValue, proposalValue) => {
  let config = {
    cancelToken: new axios.CancelToken(function executor(c) {
      changeChatCancel = c;
    })
  }

  return dispatch => {
    dispatch(changeLocalLoading(true))
    dispatch(changePing(false))
    return serverAPI.post('/chat/message', { id, proposalId: spCaseId, action, message, file, minutaId, agreedValue, hadObligation, archiveReason, archiveObservation, expectedValue, proposalValue }, config)
      .then(response => {
        dispatch(changeViewedOppositePart(false))
        dispatch(changeLocalLoading(false))
        if (action !== 'checkout') {
          dispatch(changeChat(spCaseId, { ...response.data, from: 'action' }))
        } else {
          dispatch(changeCheckout(true))
        }

        // TODO: mudar marreta para chamar pelo back-end
        if (action === 'start') {
          setTimeout(function () {
            dispatch(actionChat(id, spCaseId, 'automatic'))
          }, 1000);
        } else {
          dispatch(changePing(true))
        }
      })
      .catch(e => {
        dispatch(changeLocalLoading(false))
        dispatch(changePing(true))
      })
  }
}

export const pingChat = (id, spCaseId, lastMessageId) => {
  return function (dispatch) {
    return serverAPI.get(`/chat/ping/${spCaseId}/${lastMessageId}`)
      .then(response => {
        const items = response.data
        if (!_.isEmpty(items)) {
          items.map(item => {
            dispatch(changeChat(spCaseId, item))
          })
        }
      })
      .catch(_ => {})
  }
}

export const downloadContract = (spCaseId, fileRequest, minutaId) => {
  return dispatch => {
    let url = `/file/download/${fileRequest}/${spCaseId}`

    if (fileRequest === 'minuta' || fileRequest === 'protocolo') {
      url = url + `/${minutaId}`
    }

    serverAPI.get(url)
      .then(response => {
        const byteCharacters = atob(response.data.base64);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers)
        const file = new Blob([byteArray], { type: response.data.type })

        dispatch(changeFile(file))
      })
      .catch(_ => {})
  }
}

export const uploadContract = (id, spCaseId, type, file) => {
  let formData = new FormData();

  formData.append('id', id)
  formData.append('proposalId', spCaseId)
  formData.append('type', type)
  formData.append('file', file)

  let config = {
    cancelToken: new axios.CancelToken(function executor(c) {
      uploadContractCancel = c;
    })
  }

  return dispatch => {
    dispatch(changeLocalLoading(true))
    serverAPI.post('/chat/upload', formData, config)
      .then(response => {
        dispatch(changeChat(spCaseId, { ...response.data, from: 'action' }))
        dispatch(changeLocalLoading(false))
      })
      .catch(e => {
        dispatch(changeLocalLoading(false))
      })
  }
}

export const saveMoreInfos = (id, maxValue, provision, ps, deadline) => {
  let actualMaxValue = maxValue ? maxValue : null
  let actualProvision = provision ? provision : null
  let actualPs = ps ? ps : null
  let actualDeadline = deadline ? deadline : null

  if (typeof (maxValue) === 'string') {
    actualMaxValue = String(maxValue).replace(/\./g, '').replace(',', '.')
  }

  if (typeof (provision) === 'string') {
    actualProvision = String(provision).replace(/\./g, '').replace(',', '.')
  }

  return dispatch => {
    serverAPI.put(`/case/additional-info/${id}`, { maxValue: actualMaxValue, provision: actualProvision, ps: actualPs, deadline: actualDeadline })
      .then(response => {
        console.log(response)
      })
      .catch(_ => {})
  }
}

export const saveMoreInfosComment = (spCaseId, userId, comment) => {
  return dispatch => {
    serverAPI.put(`/case/comment/${spCaseId}`, { comment })
      .then(response => {
      })
      .catch(_ => {})
  }
}

export const fetchArchiveReasons = () => {
  return dispatch => {
    serverAPI.get('/case/archive-reason')
      .then(response => {
        dispatch(changeArchiveReasons(response.data))
      })
      .catch(_ => {})
  }
}

export const createInviteChannel = (caseId = null, channel, email = null) => {
  return dispatch => {
    serverAPI.post('invite/create', { caseId, channel, email })
      .then(response => {
      }).catch(e => {
        console.log(e)
      })
  }
}

export const validateFile = (file) => {
  let isValid = true
  let message = []

  if (file.type !== 'application/pdf') {
    isValid = false
    message.push("Somente é possível inserir arquivos <i>*.pdf</i>.")
  }
  if (file.size >= 20 * 1000 * 1000) {
    isValid = false
    message.push("Não é possível inserir um arquivo maior que <i>20MB</i>.")
  }

  return { isValid, message: `<ul><li>${message.join('</li><li>')}</li></ul>` }
}